module.exports = __webpack_public_path__ + "assets/overlay-lower-teeth.a7dfffb1f65b8f7d56a7174b175f8fa9.png";